import React, {  } from 'react';
import s from './WebsiteMap.scss';
import { WebsiteMapBlock } from './WebsiteBlock';
import { navConfig } from './navConfig';

export const WebsiteMap = () => {
    return (
        <div className={s.container}>
            <div className={s.block}>
                <img className={s.logo} src="//statics.itc.cn/static/images/awesome/logo-opacity.png" alt=""/>
            </div>
            {
                navConfig.map((e, i) =>
                    <WebsiteMapBlock key={i} data={e.config} spm={e.spm}/>,
                )
            }
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/pages/HomePageV2/components/WebsiteMap/index.tsx